module.exports = __webpack_public_path__ + "static/media/tesla.4ffd8457.jpeg";